import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import { useManageEmailNotifyModalStore } from './Modals/NotifyModal/ManageEmailNotifyModalStore';

import { MLButton } from 'components/Button/Button';

import './EmailNotificationBTB.scss';

interface Props {
  objectSlug: string;

  mct_receive_messages: boolean;
  srbm_receive_messages: boolean;
  smst_receive_messages: boolean;
  srst_receive_messages: boolean;

  mct_count: number;
  srbm_count: number;
  smst_count: number;
  srst_count: number;
}

const EmailNotificationBTN: React.FC<Props> = ({
  objectSlug,
  mct_receive_messages,
  srbm_receive_messages,
  smst_receive_messages,
  srst_receive_messages,
  mct_count,
  srbm_count,
  smst_count,
  srst_count,
}) => {
  const { onManageEmailNotifyModalOpen } = useManageEmailNotifyModalStore();
  const { t } = useTranslation();

  const channels = useMemo(
    () => [
      { key: 'mct', label: 'MCT', available: mct_count > 0, enabled: mct_receive_messages },
      { key: 'srbm', label: 'SRBM', available: srbm_count > 0, enabled: srbm_receive_messages },
      { key: 'smst', label: 'SMST', available: smst_count > 0, enabled: smst_receive_messages },
      { key: 'srst', label: 'SRST', available: srst_count > 0, enabled: srst_receive_messages },
    ],
    [
      mct_count,
      srbm_count,
      smst_count,
      srst_count,
      mct_receive_messages,
      srbm_receive_messages,
      smst_receive_messages,
      srst_receive_messages,
    ],
  );

  const availableChannels = channels.filter(c => c.available);
  const enabledChannels = availableChannels.filter(c => c.enabled);

  const hasAny = enabledChannels.length > 0;
  const innerText = hasAny ? enabledChannels.map(c => c.label).join(', ') : undefined;

  const BgColor = (() => {
    switch (true) {
      case mct_receive_messages || srbm_receive_messages || smst_receive_messages || srst_receive_messages:
        return 'success';
      default:
        return 'primary';
    }
  })();

  return (
    <MLButton
      title={t('ClientTable.titles.helper-email-text')}
      size="no-spaces"
      icon="ri-notification-3-fill "
      isGhost
      color={BgColor}
      classNames={!innerText ? 'btn-icon' : ''}
      innerText={innerText}
      onClick={() =>
        onManageEmailNotifyModalOpen(
          objectSlug,
          mct_receive_messages,
          srbm_receive_messages,
          smst_receive_messages,
          srst_receive_messages,
          mct_count,
          srbm_count,
          smst_count,
          srst_count,
          availableChannels.map(c => c.key),
        )
      }
    />
  );
};

export default EmailNotificationBTN;
